import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../components/AuthingButton";
import { DownRcode } from "../../components/DownRcode";
import { tryNow } from "../../utils";
import "./styles.less";

export const SolutionBanner = ({
  background,
  title,
  subtitle,
  link,
  download,
  tryon = false,

  rcodeUrl,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <section
        className="solution-banner"
        style={{
          background: `url("//files.authing.co/authing-website/${background}")
      center top/contain no-repeat,
    linear-gradient(95.53deg, #e1e6f5 4.21%, #b0caff 96.47%)`,
        }}
      >
        <div className="solution-banner-container">
          <h3 className="title">{title}</h3>
          <div className="subtitle">{subtitle}</div>

          <AuthingButton
            style={{ marginRight: 24 }}
            onClick={() => {
              window.open(link);
            }}
          >
            {t("solution.okta.banner.consult")}
          </AuthingButton>
          {tryon ? (
            <AuthingButton mode="light" onClick={() => tryNow()}>
              {t("common.try-on")}
            </AuthingButton>
          ) : rcodeUrl ? (
            <DownRcode url={rcodeUrl}>
              <AuthingButton
                mode="light"
                // onClick={() => {
                //   window.open(download);
                // }}
              >
                {t("solution.okta.banner.solution")}
              </AuthingButton>
            </DownRcode>
          ) : (
            <AuthingButton
              mode="light"
              // onClick={() => {
              //   window.open(download);
              // }}
            >
              {t("solution.okta.banner.solution")}
            </AuthingButton>
          )}
        </div>
      </section>
    </div>
  );
};
